"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: _defineProperty({
      display: 'flex',
      alignItems: 'flex-start',
      padding: theme.spacing(2),
      cursor: 'pointer'
    }, theme.breakpoints.up('sm'), {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: theme.spacing(6, 4)
    }),
    figure: _defineProperty({
      margin: theme.spacing(0, 2, 0, 0),
      width: 60,
      height: 60
    }, theme.breakpoints.up('sm'), {
      marginRight: 0,
      marginBottom: theme.spacing(6),
      width: 100,
      height: 100
    }),
    image: _defineProperty({
      width: 60,
      height: 'auto'
    }, theme.breakpoints.up('sm'), {
      width: 100,
      height: 'auto'
    }),
    skeleton: _defineProperty({
      width: 60,
      height: 60
    }, theme.breakpoints.up('sm'), {
      width: 100,
      height: 100
    }),
    title: _defineProperty({}, theme.breakpoints.up('sm'), {
      marginBottom: theme.spacing(2)
    }),
    description: {}
  };
};

var _default = styles;
exports.default = _default;